<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            :model="form"
            layout="inline"
          >
            <a-form-model-item
              label="基地："
              prop="baseId"
            >
              <a-select
                v-model="form.baseId"
                placeholder="请选择基地"
                allow-clear
                show-search
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, checkResource)"
              >
                <a-select-option
                  v-for="item in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </div>
        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @checkResource="checkResource"
            @exportResource="exportData"
          />
        </div>
      </div>
    </div>
    <div class="table">
      <a-table
        :data-source="dataSource"
        :loading="loading"
        :columns="columns"
        :pagination="pagination"
        :expanded-row-keys="openRowKeys"
        row-key="baseId"
        @expand="handleClickRow"
        @change="handleTableChange"
      >
        <a-table
          slot="expandedRowRender"
          slot-scope="record"
          :loading="loading2"
          :columns="innerColumns"
          :data-source="record.innerDataSource"
          :row-key="(item, index1) => index1"
          :pagination="false"
        />
      </a-table>
    </div>
  </div>
</template>

<script>
import {
  queryTotalStatistics,
  querySubTotalStatistics,
  exportTotalStatistics
} from '@/api/dispenseflow.js'
import {
  queryBases
} from '@/api/common.js'
import { excelDown, filterOption, inputKeydown } from '@/utils/utils.js'
import { pagination } from '@/constants/tableSetting'

const columns = [
  {
    title: '基地',
    dataIndex: 'baseName',
    key: 'baseName'
  },
  {
    title: '采购款',
    dataIndex: 'purchaseAmount',
    key: 'purchaseAmount'
  },
  {
    title: '配比系数',
    dataIndex: 'resourceRatio',
    key: 'resourceRatio'
  },
  {
    title: '资源总额',
    dataIndex: 'resourceAmount',
    key: 'resourceAmount'
  },
  {
    title: '资源发放累计总额',
    dataIndex: 'distributionAmount',
    key: 'distributionAmount'
  },
  {
    title: '资源剩余累计总额',
    dataIndex: 'surplusAmount',
    key: 'surplusAmount'
  },
  {
    title: '发券流水累计',
    dataIndex: 'couponsAmount',
    key: 'couponsAmount'
  },
  {
    title: '发券流水待转化',
    dataIndex: 'notConvert',
    key: 'notConvert'
  }
]
const innerColumns = [
  {
    title: '年度',
    dataIndex: 'year',
    key: 'year'
  },
  {
    title: '发放总额',
    dataIndex: 'distributionAmount',
    key: 'distributionAmount'
  },
  {
    title: '发券流水',
    dataIndex: 'couponsAmount',
    key: 'couponsAmount'
  }

]

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'checkResource'
  },
  {
    title: '导出',
    type: 'primary',
    action: 'exportResource',
    apis: ['@baseInfo/Export_Bases']

  }
]
export default {
  data () {
    return {
      headerActions,
      columns,
      innerColumns,
      baseOptions: [],
      dataSource: [],
      innerDataSource: [],
      openRowKeys: [],
      loading: true,
      loading2: false,
      pagination,
      form: {
        baseId: undefined
      }
    }
  },
  mounted () {
    this.fetchData()
    this.fetchSearchOptions()
  },
  methods: {
    excelDown,
    filterOption,
    inputKeydown,
    checkResource () {
      this.pagination.current = 1
      this.fetchData()
    },
    async fetchData () {
      this.openRowKeys = []
      this.loading = true
      await queryTotalStatistics({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        baseId: this.form.baseId
      }).then((data) => {
        this.pagination.total = data.totalRecords
        this.dataSource = data.result ? data.result : []
      })
      this.loading = false
    },
    async fetchSearchOptions () {
      await queryBases().then((data) => {
        this.baseOptions = data
      })
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.fetchData()// 获取表格数据的接口
    },
    async handleClickRow (expanded, record) {
      if (expanded) {
        this.openRowKeys.push(record.baseId)
        this.loading2 = true
        await querySubTotalStatistics({
          baseId: record.baseId
        }).then((data) => {
          record.innerDataSource = data
          this.loading2 = false
        })
      } else {
        this.openRowKeys.pop(record.baseId)
      }
    },
    async exportData () {
      await exportTotalStatistics({
        baseId: this.form.baseId
      }).then((data) => {
        this.excelDown(data, '资源发放与流水汇总')
      })
    },
    handleCancel () {
      this.exportVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.ant-table-expanded-row {
  > td {
    padding: 6px 0 !important;
  }
}
</style>
